import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import { arrayBufferToBase64 } from 'src/Admin/utils/common';
import ToastMessage from 'src/Member/components/common/ToastMessage';
import { toast } from 'react-toastify';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import useMessageAndNotification from '../../common-hook/useMessageAndNotification';

const useUpdateAndReminder = ({ selectedTabLocal }) => {
  //Filter Configs
  const SORT_BY_DROPDOWN_OPTIONS = [
    { label: 'Latest', value: 'desc' },
    { label: 'Oldest', value: 'asc' },
  ];

  const AttachmentOptions = [
    //{ label: 'Select', value: '' },
    { label: 'With Attachment', value: true },
    { label: 'Without Attachment', value: false },
  ];

  const [sortByData, setSortByData] = useState(SORT_BY_DROPDOWN_OPTIONS[0]);
  //for attachments
  const [attachmentData, setAttachmentData] = useState([]);
  //for type
  const [typeData, setTypeData] = useState([]);
  const [typeOptionList, setTypeOptionList] = useState([]);
  const [typeListValues, setTypeListValues] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [searchTextDebounce, setSearchTextDebounce] = useState('');

  const onSearch = (e) => {
    setSearchText(e?.target?.value);
    if (e?.target?.value?.length > 2 || e?.target?.value?.length === 0) {
      setCurrentPage(1);
      debouncedCall(e?.target?.value);
    }
  };

  const markeMessageAsRead = (oid, isRead = true) => {
    const payload = {
      ReadFlag: [
        {
          oid: oid,
          IsRead: isRead,
        },
      ],
    };
    //eslint-disable-next-line no-unused-vars
    const responseMessageListResp = axiosInstance.post(
      APIEndpoints.postMarkMessageIsRead(),
      payload,
    );
    responseMessageListResp
      .then((res) => {
        if (res?.status === 201) {
          updateNotificationCount();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //List and Detail Section Configs
  const [listLoading, setListLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [updateAndReminderData, setUpdateAndReminderData] = useState([]);

  const displayPaginationMininumCount = 10;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [listApiDataNotFoundError, setListApiDataNotFoundError] =
    useState(false);
  const [listApiServerError, setListApiServerError] = useState(false);

  const { updateNotificationCount } = useMessageAndNotification({
    updateReminderListData: updateAndReminderData,
    setUpdateReminderListData: setUpdateAndReminderData,
    updateReminderDetailData: selectedIndex,
  });

  const getTypeList = async () => {
    try {
      const responseTypeCategory = await axiosInstance.get(
        APIEndpoints.getTypeCategoryList(),
      );
      const typeListData =
        responseTypeCategory?.data?.Response?.MessageCategoryMaster;

      const typeCategoryValues = typeListData.map((item) => {
        return {
          label: item?.Categorydesc,
          value: item?.Categorycode,
          ...item,
        };
      });
      const uniqueTypeData = [];
      for (let i = 0; i < typeCategoryValues.length; i++) {
        if (
          !uniqueTypeData.find(
            (item) => item.label === typeCategoryValues[i]?.value,
          )
        ) {
          uniqueTypeData.push(typeCategoryValues[i]);
        }
      }
      setTypeListValues(typeListData);
      setTypeOptionList(uniqueTypeData);
    } catch (err) {
      console.log('err :', err);
    }
  };

  const ListUser = (index) => {
    setSelectedIndex(index);
    const selectedData = updateAndReminderData[index];
    !selectedData.isread &&
      selectedTabLocal === 'notification' &&
      markeMessageAsRead(selectedData.id, true);
  };

  const pageSizeHandler = (val) => {
    setCurrentPage(1);
    setPageSize(val?.value || 10);
  };

  const paginationHandler = (val) => {
    setCurrentPage(val);
  };

  const getSanitizedContent = (content) => {
    let modifiedContent = '';
    if (
      content?.toString()?.startsWith('"') &&
      content?.toString()?.endsWith('"')
    ) {
      modifiedContent = content?.substring(1, content?.length - 1);
    } else {
      modifiedContent = content;
    }
    const splitedContent = modifiedContent
      ?.toString()
      ?.replace(/\\n/g, '')
      ?.replace(/\n/g, '<br />');
    return splitedContent;
  };

  //Reset Filter function
  const resetFilterHandler = () => {
    setCurrentPage(1);
    setPageSize(10);
    setSortByData(SORT_BY_DROPDOWN_OPTIONS[0]);
    setTypeData([]);
    setAttachmentData([]);
    setSearchText('');
    setListApiDataNotFoundError(false);
    setListApiServerError(false);
  };

  //API
  const getUpdateAndReminderList = async () => {
    setListLoading(true);
    let filterParams = '';
    if (sortByData?.value) {
      filterParams = filterParams + `SortDirection/${sortByData?.value}`;
    }
    if (searchText?.length > 2) {
      filterParams = filterParams + `/searchkey/${searchText}`;
    }
    if (typeData?.value) {
      filterParams = filterParams + `/type/${typeData?.value}`;
    }
    if (attachmentData?.label) {
      filterParams = filterParams + `/attachments/${attachmentData?.value}`;
    }
    if (currentPage) {
      filterParams = filterParams + `/pagenumber/${currentPage}`;
    }
    if (pageSize) {
      filterParams = filterParams + `/pagesize/${pageSize}`;
    }

    try {
      setListApiDataNotFoundError(false);
      setListApiServerError(false);
      const responseMessageListResp = await axiosInstance.get(
        `${APIEndpoints.getSendReceiveMessage()}93b7c590-f1bb-456e-ab44-4e5d77f00cf7/messagesentreceived/R${
          filterParams && `/${filterParams}`
        }`,
      );
      const { Pagination } = responseMessageListResp?.data?.Response || {
        PageNumber: 1,
        PageSize: 10,
        TotalRecords: 0,
      };
      const responseMessageList =
        responseMessageListResp.data.Response.listOfRRMessageDTOObj;
      const listData = [];
      if (responseMessageList?.length > 0) {
        responseMessageList.map((item, index) => {
          listData.push({
            id: item?.oid || index,
            indexValue: index,
            FirstName: '',
            LastName: '',
            isDmsDoc: item?.DmsDocument,
            isread: item?.isread,
            EventTitle: item?.eventtitle,
            EventDesc: item?.eventdesc,
            MessagecategorymasterDTOObj: {
              Categorydesc: item?.messagecategorymaster?.categorydesc,
            },
            attachments: item?.attachments,
            attachmentsDetail: item?.rrmessageDocumentDetailDTO,
            ReceivedDateTime: item?.receiveddatetime,
          });
          return 0;
        });
        setSelectedIndex(0);
        setUpdateAndReminderData(listData);
        !listData[0].isread &&
          selectedTabLocal === 'notification' &&
          markeMessageAsRead(listData[0].id, true);
        setTotalRecords(Pagination?.TotalRecords);
      }
    } catch (error) {
      console.log('error :', error);
      if (error.toString().includes('404')) {
        setListApiDataNotFoundError(true);
        setListApiServerError(true);
      }
      setListApiServerError(true);
      setUpdateAndReminderData([]);
      setTotalRecords(0);
    } finally {
      setListLoading(false);
    }
  };

  const downloadFile = async (reportName, byte, contentType) => {
    const actualData = arrayBufferToBase64(byte);
    const link = document.createElement('a');
    link.setAttribute('href', `data:${contentType};base64,` + actualData);
    link.setAttribute('download', reportName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadDmsDocumentHandler = async (item) => {
    try {
      const documentData = await axiosInstance.get(
        `${APIEndpoints.getDocument() + item?.Oid}`,
        { responseType: 'arraybuffer' },
      );
      const contentType = documentData?.headers['content-type'];
      downloadFile(item?.OrigFileName, documentData?.data, contentType);
    } catch (error) {
      console.log('error :', error);
      if (error?.toString()?.includes('404')) {
        console.log('404 error');
        toast.error(
          <ToastMessage
            type="error"
            title="File not found!"
            subTitle="Could not download the file. Contact your Administrator for more information."
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Something went wrong!"
            subTitle="Could not download the file. Try again later."
          />,
        );
      }
    }
  };

  const downloadNonDmsDocumentHandler = async (item) => {
    try {
      const docLocation = btoa(item?.Location);
      const responseDetails = await axiosInstance.get(
        `${APIEndpoints.getDocumentsDownload()}doclocation/${docLocation}/id/${
          item?.DocControlNo
        }`,
        { responseType: 'arraybuffer' },
      );
      const contentType = responseDetails.headers['content-type'];
      downloadFile(item?.OrigFileName, responseDetails?.data, contentType);
    } catch (error) {
      if (error?.toString()?.includes('404')) {
        console.log('404 error');
        toast.error(
          <ToastMessage
            type="error"
            title="File not found!"
            subTitle="Could not download the file. Contact your Administrator for more information."
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Something went wrong!"
            subTitle="Could not download the file. Try again later."
          />,
        );
      }
    }
  };

  const downloadFileHandler = async (item) => {
    if (item?.isDmsDoc) {
      downloadDmsDocumentHandler(item);
    } else {
      downloadNonDmsDocumentHandler(item);
    }
  };

  const downloadAllFileHandler = async (items) => {
    items?.attachmentsDetail?.map(async (file) => {
      const uploadResponse = await (items?.isDmsDoc
        ? downloadDmsDocumentHandler(file)
        : downloadNonDmsDocumentHandler(file));
      return uploadResponse;
    });
  };

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearchTextDebounce(currentVal), 500),
    [],
  );

  useEffect(() => {
    getTypeList();
  }, []);

  useEffect(() => {
    getUpdateAndReminderList();
  }, [
    currentPage,
    pageSize,
    sortByData,
    searchTextDebounce,
    typeData,
    attachmentData,
  ]);

  useEffect(() => {
    if (selectedTabLocal === 'notification') {
      setSearchText('');
      setCurrentPage(1);
      setPageSize(10);
      setListApiDataNotFoundError(false);
      setListApiServerError(false);
      setSortByData(SORT_BY_DROPDOWN_OPTIONS[0]);
    }
  }, [selectedTabLocal]);

  return {
    SORT_BY_DROPDOWN_OPTIONS,
    sortByData,
    setSortByData,
    searchText,
    onSearch,
    listLoading,
    ListUser,
    selectedIndex,
    updateAndReminderData,
    totalRecords,
    pageSize,
    pageSizeHandler,
    currentPage,
    setCurrentPage,
    paginationHandler,
    displayPaginationMininumCount,
    listApiDataNotFoundError,
    listApiServerError,
    downloadFileHandler,
    downloadAllFileHandler,
    getSanitizedContent,
    AttachmentOptions,
    attachmentData,
    setAttachmentData,
    resetFilterHandler,
    setTypeData,
    typeData,
    typeListValues,
    typeOptionList,
  };
};
export default useUpdateAndReminder;
